import dayjs from 'dayjs';

import type {I18n} from '../i18n';

import {DEFAULT_LOCALE} from '../constants';
import {checkIsBrowserDateInUsFormat} from './checkIsBrowserDateInUsFormat';

const isDateInUsFormat = checkIsBrowserDateInUsFormat();

const dateLocaleUS = 'en-ca';
const dateLocaleNonUS = 'en-gb';

const dayjsLocales = {
  [DEFAULT_LOCALE]: isDateInUsFormat ? dateLocaleUS : dateLocaleNonUS,
};

export const initDayjs = async (language: I18n.Language) => {
  const defaultDayjsLocaleDict = await import(
    /* webpackChunkName: "dayjs-locale-[request]" */
    /* webpackExclude: /d.ts$/ */
    `dayjs/locale/${dayjsLocales[DEFAULT_LOCALE]}`
  );

  if (language !== DEFAULT_LOCALE && dayjsLocales[language]) {
    try {
      const dayjsDict = await import(
        /* webpackChunkName: "dayjs-locale-[request]" */
        /* webpackExclude: /d.ts$/ */
        `dayjs/locale/${dayjsLocales[language]}`
      );

      dayjs.locale(language, {
        ...defaultDayjsLocaleDict.default,
        ...dayjsDict.default,
      });
    } catch {
      // fallback to default locale
    }
  } else {
    dayjs.locale(language, {
      ...defaultDayjsLocaleDict.default,
    });
  }
};
